export const eRASTERPARMS = {
  MODE: 0,
  MAG: 1,
  OVERLAPPCT: 2,
  PATTERNNAME: 3,
  PATTERNNUMBER: 4,
  PATTERNLIST: 5,
  PIXELTHRESH: 6,
  CONTENTPCT: 7,
  SPEEDFACTOR: 8,
  SEQUENCESTYLE: 9
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/raster-scan/constants.js